<!--
关注组件
    V1 - 单独通过 iconfont-selector-tooltip 实现关注（Favorite），大量的实现都是通过 iconfont-selector-tooltip 封装内部实现了。
    V2 - 提供两种显示方式，新增 text 的方式。然后该组件的 props 和所有的 methods 都是为该组件提供的。
-->
<template>
    <div>
        <span v-if="!isButton_"
             :style="{ fontSize: fontSize+'px', lineHeight: lineHeight+'px', color: color_, 'font-weight': fontWeight, cursor: pointer_ }"
             :title="tooltipText_"
             @click="follows_">
            <span>{{text_}}</span>
        </span>
        <el-button v-if="isButton_"
                   type="danger"
                   style="width:100px"
                   :plain="isPlain"
                   :loading="isLoading"
                   :title="tooltipText_"
                   @click="follows_"><span v-show="!isLoading">{{text_}}</span></el-button>
    </div>
</template>

<script>
    import {follows} from "../../data/user";
    import {errorMessage, getCachedUser} from "../../utils";
    import {CachedApiSecurity} from "../../api-security";

    export default {
        name: "Follows",
        props: {
            isButton: {
                type: Boolean,
                default: true
            },
            tooltipText: {
                type: String,
                default: "关注博主"
            },
            code: String, // the profile code
            // ========================= 下面的属性都是为 Text Favorite 准备的 ==================
            defaultColor: {
                type: String,
                default: '#303133' /*element ui*/
            },
            activeColor: {
                type: String,
                default: '#909399' /*element ui*/
            },
            lineHeight: {
                type: Number,
                default: 35
            },
            fontSize: {
                type: Number,
                default: 30
            },
            fontWeight: {
                type: Number,
                defautl: 400
            }
        },
        data() {
            return {
                isFollowed: false,
                isLoading: false,
                isButton_: this.isButton,
                text_: '...'
            }
        },
        computed: {
            color_: function(){
                return this.isFollowed ? this.activeColor : this.defaultColor;
            },
            pointer_: function(){
                return this.isFollowed ? 'pointer' : 'pointer';  // 都需要 pointer，因为可以取消关注
            },
            tooltipText_: function(){
                return this.isFollowed ? '取消关注': '关注博主';
            },
            isPlain: function(){
                return this.isFollowed ? false : true;
            }
        },
        created() {
            this.init();
            // this -> 是 Favorite，下面的监听表示是 Favorite 组件监听。
            this.$EventBus.$on('signedin', () => {
                console.log('Follows, caught the signedin global event');
                this.init();
            });
            this.$EventBus.$on('signout', () => {
                console.log('Follows, caught the signout global event');
                this.init();
            });
        },
        beforeDestroy() {
            // 说是（https://juejin.cn/post/6861572888420581390），在该组件被销毁的时候，需要移除该组件对该事件的监听。
            this.$EventBus.$off('signedin')
            this.$EventBus.$off('signout');
        },
        methods: {
            init(){
                console.log('Follows init method get called~~~');
                if( CachedApiSecurity.isSignedIn() ){
                    console.log(getCachedUser().follows, this.code);
                    console.log(getCachedUser().follows.includes(this.code));
                    this.isFollowed = getCachedUser().follows.includes(this.code);
                }else{
                    this.isFollowed = false;
                }
                this.text_ = this.isFollowed ? '已关注': '关注';
            },
            /**
             * 发起关注动作; TODO interact with db.
             */
            follows_: function(){
                if( !CachedApiSecurity.isSignedIn() ){
                    console.log('the user has not cached signed in');
                    CachedApiSecurity.handleNoAuthorith();
                }else{
                    this.isLoading = true;
                    async function exec(){
                        try {
                            await follows(this.code, !this.isFollowed);
                            this.isFollowed ? this.isFollowed = false : this.isFollowed = true;
                            this.text_ = this.isFollowed ? '已关注': '关注';
                            // cache follows_ into user client.
                            this.isFollowed ? this.$store.commit('addFollows', this.code) : this.$store.commit('removeFollows', this.code);
                            // 下面 4 行代码主要是解决当点击关注按钮 toggle 回 plain 的时候，样式不发生改变的问题，需要点击下屏幕才改变（原因未知），
                            // 应该是 el-button 的一个小 bug。现在的解决办法就是让关注按钮直接重新绘制。
                            if (this.isButton_) {  // 因为是修复 button 关注，因此必须是 button 的情况下才会修复。
                                this.isButton_ = false;
                                this.$nextTick(() => {
                                    this.isButton_ = true;
                                })
                            }
                        }catch(err) {
                            console.error(err);
                            errorMessage('网络异常，关注失败，请稍后再试');
                            // 反向操作
                            // 这里无需进行任何的反向操作，和 Favorite 不同，Favrote 是提前亮（actived and inc count），而 Follows 不是。
                        }finally {
                            this.isLoading = false;
                        }
                    }
                    exec.bind(this)();
                }
            }
        }
    }
</script>

<style scoped>

    /deep/ .el-button {
        border: 0px;
    }

</style>



// WEBPACK FOOTER //
// src/components/profile/Follows.vue